import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private readonly router: Router = inject(Router);
  private readonly auth: AuthService = inject(AuthService);

  /** Redirects to the login page when there is no valid session. */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.auth.getAuthUser() === null || this.auth.isTokenExpired()) {
      this.router.navigate(['/entry'], { queryParams: { returnUrl: state.url } });
      return false;
    }
    return true;
  }
}
